import { render } from "./AddComponent.vue?vue&type=template&id=59be2506"
import script from "./AddComponent.vue?vue&type=script&lang=js"
export * from "./AddComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__